import { useTheme, type ThemePreference } from '../features/theme/ThemeContext';

const LABELS: Record<ThemePreference, string> = {
  system: 'System',
  light: 'Day',
  dark: 'Night',
};

export function ThemeToggle(): JSX.Element {
  const { preference, setPreference, resolved } = useTheme();

  return (
    <div className="theme-toggle" role="group" aria-label="Faceplate lighting">
      {(['system', 'light', 'dark'] as ThemePreference[]).map((option) => (
        <button
          key={option}
          type="button"
          className={`theme-toggle__option${preference === option ? ' theme-toggle__option--active' : ''}`}
          aria-pressed={preference === option}
          title={
            option === 'system'
              ? `Follow system (${resolved === 'light' ? 'day' : 'night'})`
              : LABELS[option]
          }
          onClick={() => setPreference(option)}
        >
          {LABELS[option]}
        </button>
      ))}
    </div>
  );
}
